"use strict";
'use es6';

require("@apollo/client");